import React, { useEffect, useState } from 'react'
import { IconSVG } from "../components/icons/CloseSVG.jsx";
import { Col, Row, Modal } from 'react-bootstrap';
import { validarEntorno } from './validarHost';
import { PopUpModal } from './PopUpModal';
import { HelpSVG } from "../components/icons/HelpSVG";
import { useTranslation } from 'react-i18next';

const ModalHelp = (props) => {

  const { t } = useTranslation();
  const hash = window.location.hash
  const [dataModal, setDataModal] = useState({})
  const [open, setOpen] = useState(false)

  function openModal() {
    setOpen(true);
  }
  const handleClose = () => {
    setOpen(false)
}


useEffect(() => {
getDataModal()
}, [])

  const getDataModal = async () =>{

    const dataReq = {
      hash: hash
    }

    const req = await validarEntorno('JSON/pop_up_modal.html', 'POST', dataReq)

    if(req.ok){
      const res = await req.json()

      setDataModal({
        ...dataModal,
        data: res,
        titulo: res.titulo,
        texto0: res.data.texto0,
        texto1: res.data.texto1,
        texto2: res.data.texto2

      })
      console.log(dataModal)
    }

  }



  return (

      <>
      <Modal
        className="loginModal modalesGenerales"
        show={open}
        centered
        onHide={handleClose}
      >

        <Modal.Header>
          <Modal.Title>
            <h4 className="pagesTitles">{t('modales.filtro_por_procesos')}</h4>
          </Modal.Title>
          <div onClick={handleClose}>
            <IconSVG />
          </div>
        </Modal.Header>
        <Modal.Body>
        <div className="leyendas-item" style={{display: "flex"}}>
        <div></div>
        {t('modales.filtro_por_procesos_descripcion')}
        </div>
{/*
        <div className="leyendas-item" style={{display: "flex"}}>
        <div style={{margin: "0px 5px 5px 0px", minWidth: "20px", minHeight: "20px", backgroundColor: "#F08700"}}> </div>
        {dataModal.texto1}
        </div>
        <div className="leyendas-item" style={{display: "flex"}}>
        <div style={{margin: "0px 5px 0px 0px", minWidth: "20px", minHeight: "20px", backgroundColor: "#F9CF00"}}> </div>
        {dataModal.texto2}
        </div> */}
        </Modal.Body>
      </Modal>

      <div
        style={{ position: "absolute", right: 40, top: 30, cursor: "pointer", paddingRight:'3%'}}
        onClick={() => {
        openModal();
        }}
      >
        <HelpSVG />
      </div>

      </>




  )
}

export default ModalHelp
